<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    linesCount?: number
  }>(),
  {
    linesCount: 5,
  }
)
</script>

<template>
  <div
    role="status"
    class="animate-pulse space-y-8 py-5 md:flex md:space-x-8 md:space-y-0 rtl:space-x-reverse"
  >
    <div class="w-full">
      <div
        class="mb-4 h-2.5 max-w-[600px] rounded-none bg-neutral-200 dark:bg-neutral-700"
      ></div>
      <div
        v-for="(line, index) in props.linesCount"
        :key="index"
        class="mb-5 h-2 max-w-[600px] rounded-none bg-neutral-200 dark:bg-neutral-700"
      />
    </div>
  </div>
</template>
